import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h3 {...{
      "id": "boolean-feature-flags"
    }}>{`Boolean feature flags`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-kotlin"
      }}>{`import com.posthog.PostHog

if (PostHog.isFeatureEnabled("flag-key")) {
    // Do something differently for this user

    // Optional: fetch the payload
    val matchedFlagPayload = PostHog.getFeatureFlagPayload("flag-key")
}
`}</code></pre>
    <h3 {...{
      "id": "multivariate-feature-flags"
    }}>{`Multivariate feature flags`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-kotlin"
      }}>{`import com.posthog.PostHog

if (PostHog.getFeatureFlag("flag-key") == "variant-key") { // replace 'variant-key' with the key of your variant
    // Do something differently for this user

    // Optional: fetch the payload
    val matchedFlagPayload = PostHog.getFeatureFlagPayload("flag-key")
}
`}</code></pre>
    <h3 {...{
      "id": "ensuring-flags-are-loaded-before-usage"
    }}>{`Ensuring flags are loaded before usage`}</h3>
    <p>{`Every time a user opens the app, we send a request in the background to fetch the feature flags that apply to that user. We store those flags in the storage.`}</p>
    <p>{`This means that for most screens, the feature flags are available immediately – `}<strong parentName="p">{`except for the first time a user visits`}</strong>{`.`}</p>
    <p>{`To handle this, you can use the `}<inlineCode parentName="p">{`onFeatureFlags`}</inlineCode>{` callback to wait for the feature flag request to finish:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-kotlin"
      }}>{`import com.posthog.PostHog
import com.posthog.android.PostHogAndroidConfig
import com.posthog.PostHogOnFeatureFlags

// During SDK initialization
val config = PostHogAndroidConfig("<ph_project_api_key>").apply {
    onFeatureFlags = PostHogOnFeatureFlags {
        if (PostHog.isFeatureEnabled("flag-key")) {
            // do something
        }
    }
}

// And/Or manually the SDK is initialized
PostHog.reloadFeatureFlags {
    if (PostHog.isFeatureEnabled("flag-key")) {
        // do something
    }
}
`}</code></pre>
    <h3 {...{
      "id": "reloading-feature-flags"
    }}>{`Reloading feature flags`}</h3>
    <p>{`Feature flag values are cached. If something has changed with your user and you'd like to refetch their flag values, call:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-kotlin"
      }}>{`import com.posthog.PostHog

PostHog.reloadFeatureFlags()
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      